import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlurLinearIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blur_linear"}/>
}
